import React, { useEffect, useState } from 'react';
import { Loader, withErrorBoundary } from '@nile/components';
import { useIntl } from 'react-intl';
import { isEmpty } from 'lodash';
import { useLazyQuery } from '@apollo/client';
import { onQuerySearch } from '@nile/reports/src/modules/EfficiencyReport/graphql/resolver';
import { getTransformedData } from '@nile/reports/src/modules/charts/utils/chart-transformation';
import EChart from '@nile/reports/src/modules/charts/components/subpages/EChart';

const RenderSuperChart = (prop) => {
  const { api, trendType, selectedClient = null, condition } = prop;

  const intl = useIntl();

  const [chartOption, setChartOption] = useState({});
  const [loading, setLoading] = useState(true);
  const { client, query } = onQuerySearch(api);

  const [getClientSpecificRanking] = useLazyQuery(query, {
    client,
    fetchPolicy: 'network-only',
    onCompleted(res) {
      const chartoption = getTransformedData(res[api], intl);
      setChartOption(chartoption);
      setLoading(false);
    },
    onError() {
      setLoading(false);
    }
  });

  useEffect(() => {
    let requestIp = {
      trendType: trendType,
      client: {
        accountId: `${selectedClient}`
      }
    };
    if (!isEmpty(condition)) {
      requestIp = {
        ...requestIp,
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'ticketCategory',
              operator: 'is',
              value: condition
            }
          ]
        }
      };
    }
    if (!isEmpty(query)) {
      setLoading(true);
      getClientSpecificRanking({ variables: { input: requestIp } });
    }
  }, [query, selectedClient, condition]);

  if (loading) {
    return (
      <div className="flex-center min-height-300">
        <Loader />
      </div>
    );
  }

  return (
    <div className="min-height-300">
      <EChart
        isEfficiencyReport
        chartOptions={chartOption}
        chartType={prop?.defaultChartType}
        reportType={prop?.reportsContext?.activeReport?.reportType}
        opts={{
          height: '250'
        }}
      />
    </div>
  );
};

export default withErrorBoundary(RenderSuperChart);
